import {useState, useEffect} from 'react';
import api from '../../../config.js';
import './order.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaEye } from 'react-icons/fa';
import { getPermission, showMessageError } from '../../../classes/functions';
import { Link } from 'react-router-dom';

import ReactTooltip from "react-tooltip";
import HeaderListing from '../../../components/HeaderListing/index.js';
import TablePagination from '../../../components/TablePagination/index.js';

export default function OrderServices(){
  const [list, setList] = useState([]);
  const [listStatus, setListStatus] = useState([]);  
  const [termSearch, setTermSearch] = useState('');
  const [pesquisa_status, setPesquisaStatus] = useState('');
  
  //Pagination
  const [itensByPage, setItensByPage] = useState(50);

  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  
  const [carrying, setCarrying] = useState(true);
  
  let delay;
  function search() {
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      let data = {
        data: {
          status: pesquisa_status,
          termSearch: termSearch,
          page: page,
          qtdePage: qtdePage,
        }
      };
  
      api.post("/api/order_services/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdePage);
          
          setCarrying(false);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }, 750);
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  useEffect(() => {
    search();
  }, [pesquisa_status, termSearch, page, qtdePage]);
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <HeaderListing name="Controle de Ordem de Serviço" url="/order_services/cadastrar" permission="OPERACOES - ORDEM SERVICO - CADASTRO" carrying={carrying} search={search} itensByPage={itensByPage} setItensByPage={setItensByPage} termSearch={termSearch} setTermSearch={setTermSearch} pesquisa_status={pesquisa_status}>
      <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">
                  <div className="formDiv">
                    <select value={pesquisa_status} onChange={(e) => setPesquisaStatus(e.target.value)} >
                      <option value="">STATUS</option>
                      {listStatus.map((item, index) => (
                        <option key={index} value={item.chave}>{item.descricao}</option>
                      ))}
                    </select>
                  </div>
                </th>
                <th scope="col">Data Abertura</th>
                <th scope="col">Hora Abertura</th>
                <th scope="col">Documento</th>
                <th scope="col">Serviço</th>
                <th scope="col">Cliente</th>
                <th scope="col">Observação</th>
                <th scope="col">Tarefa</th>
                <th scope="col">Data Finalização</th>
                <th scope="col">Hora Finalização</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="Tipo">{item.status}</td>
                    <td data-label="Tipo">{item.data_abertura}</td>
                    <td data-label="Tipo">{item.hora_abertura}</td>
                    <td data-label="Tipo">{item.documento}</td>
                    <td data-label="Tipo">{item.servico}</td>
                    <td data-label="Tipo">{item.cliente}</td>
                    <td data-label="Tipo">{item.observacao}</td>
                    <td data-label="Tipo">{item.tarefa}</td>
                    <td data-label="Tipo">{item.data_finalizacao}</td>
                    <td data-label="Tipo">{item.hora_finalizacao}</td>
                    <td data-label="Opções">
                      {getPermission('OPERACOES - ORDEM SERVICO - CADASTRO') && <Link className="action" to={`/order_services/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/order_services/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={11}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} pesquisa_status={pesquisa_status} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/order_services/getSearch" params={{}}/>
      </HeaderListing>
    </div>
  )
}